import React from "react";
import { Link } from "react-router-dom";
import MenuNavbar from "../function-components/MenuNavbar";
import Floaticons from "../function-components/Floaticons";
import "./Industry.css";
import "./SLFComponents/Specializations.css";
import IndustryBannerCarousel from "./IndustryBannerCarousel";

function Industry() {
  return (
    <>
      <div className="banner-container">
        <IndustryBannerCarousel />
        <MenuNavbar />
      </div>
      <Floaticons />
      <div className="specialization-main-container">
        <div className="SSA-container">
          <div className="SSA-wrap industry">
            <div className="SSA-row">
              <div className="SSA-box">
                {/* <a href="https://atci.lkm-securitylearnings.accenture.com/Cyberbit/home" target='_blank'> */}
                <img
                  src="./images/Industry/New/Banking.png"
                  alt="SSA-img"
                  className="SSA-img"
                />
                <div className="SSA-box-content">
                  <h3>Banking</h3>
                  <p>
                    The banking industry is one of the key drivers of most
                    economies because it channels funds to borrowers with
                    productive investments. Get to know your Banking clients
                    better by learning how banks function, the revenue
                    generation model, banking operations, segments and operating
                    model.
                  </p>
                  {/* <a
                    href="https://atci.lkm-securitylearnings.accenture.com/Cyberbit/home"
                    target="_blank"
                  >
                    Cyberbit 2.0
                  </a> */}
                </div>
                {/* </a> */}
              </div>

              <div className="SSA-box">
                {/* <a href="https://atci.lkm-securitylearnings.accenture.com/Cyberbit/home" target='_blank'> */}
                <img
                  src="./images/Industry/New/Insurance.png"
                  alt="SSA-img"
                  className="SSA-img"
                />
                <div className="SSA-box-content">
                  <h3>Insurance</h3>
                  <p>
                    Prep up your Insurance industry know-how through this
                    course. Learn about the types of Insurance companies,
                    insurance and financial products, the key sectors, business
                    drivers and business model of an insurance firm.
                  </p>
                  {/* <a
                    href="https://ts.accenture.com/sites/SecurityLearningGuidanceWizard/SecurityAcademy/SiteAssets/index.aspx#Wizard"
                    target="_blank"
                  >
                    Security Academy
                  </a> */}
                </div>
                {/* </a> */}
              </div>

              <div className="SSA-box">
                <Link to={"/securitySchools"} className="calendar-link">
                  <img
                    src="./images/Industry/New/Telecom-&-Media.png"
                    alt="SSA-img"
                    className="SSA-img"
                  />
                  <div className="SSA-box-content">
                    <h3>Telecom & Media</h3>
                    <p>
                      Connecting people, information and business through
                      technology forms the core of Telecom & media companies.
                      Learn how this industry functions, the core services,
                      newest trends and the impact of digital disruption through
                      this course.
                    </p>
                    {/* <a href="https://ts.accenture.com/sites/SecurityLearningGuidanceWizard/SecurityAcademy/SiteAssets/index.aspx#Wizard" target="_blank">Security Academy (accenture.com)</a> */}
                  </div>
                </Link>
              </div>

              <div className="SSA-box">
                {/* <a href="https://in.accenture.com/technologyecosystemventures/partners/" target='_blank'> */}
                <img
                  src="./images/Industry/New/LifeScience.png"
                  alt="SSA-img"
                  className="SSA-img"
                />
                <div className="SSA-box-content">
                  <h3>Life Science</h3>
                  <p>
                    The technological and digital advances coupled with
                    increased health risks have led to the exponential growth of
                    life sciences industry. Learn about clinical research, drug
                    discovery, electronic health records, pharmaceutical
                    landscape and medical devices in this course.
                  </p>
                  {/* <a
                    href="https://ts.accenture.com/sites/SecurityLearningGuidanceWizard/SecurityAcademy/SiteAssets/index.aspx#Ecosystem"
                    target="_blank"
                  >
                    Ecosystem Partner Learnings
                  </a> */}
                </div>
                {/* </a> */}
              </div>

              <div className="SSA-box">
                <Link
                  to={"/securityTrainingCalendar"}
                  className="calendar-link"
                >
                  <img
                    src="./images/Industry/New/Retail.png"
                    alt="SSA-img"
                    className="SSA-img"
                  />
                  <div className="SSA-box-content">
                    <h3>Retail</h3>
                    <p>
                      The retail industry is constantly evolving, and it is
                      imperative we keep up with the latest trends and nuances
                      of this industry to speak the language of our client.
                      Learn more about types of retail store, consumer spending,
                      supply chain, merchandising, online retailing, Retail
                      Industry Process model in this course.
                    </p>
                    {/* <a href="/securityTrainingCalendar" target="_blank">Security Training Calendar (accenture.com)</a> */}
                  </div>
                </Link>
              </div>

              <div className="SSA-box">
                {/* <a href="https://ts.accenture.com/sites/IS-Learning/Security/Pages/default.aspx" target='_blank'> */}
                <img
                  src="./images/Industry/New/Energy.png"
                  alt="SSA-img"
                  className="SSA-img"
                />
                <div className="SSA-box-content">
                  <h3>Energy</h3>
                  <p>
                    The energy industry is the totality of all the industries
                    involved in the production and sale of energy, including
                    fuel extraction, manufacturing, refining and distribution. 
                    This course helps you to understand and analyze Oil and Gas
                    industry value chain proposition; insights and emerging
                    scenario of Oil & Gas industry; and the growth drivers and
                    demand factors.
                  </p>
                  {/* <a
                    href="https://ts.accenture.com/sites/IS-Learning/Security/Pages/default.aspx"
                    target="_blank"
                  >
                    Certification
                  </a> */}
                </div>
                {/* </a> */}
              </div>

              <div className="SSA-box">
                <img
                  src="./images/Industry/New/Healthcare.png"
                  alt="SSA-img"
                  className="SSA-img"
                />
                <div className="SSA-box-content">
                  <h3>Health Care</h3>
                  <p>
                    With the advent of new technology, changing healthcare acts
                    and reforms have significantly transformed the healthcare
                    industry. In this course, you will learn about healthcare
                    payers, providers, healthcare services, US healthcare system
                    and regulations, and public health overview.
                  </p>
                  {/* <a href="#">Coming Soon</a> */}
                </div>
              </div>

              <div className="SSA-box">
                <img
                  src="./images/Industry/New/NaturalResources.png"
                  alt="SSA-img"
                  className="SSA-img"
                />
                <div className="SSA-box-content">
                  <h3>Natural Resources</h3>
                  <p>
                    The natural resources is one of the most sought-after
                    industries. Natural resources contribute positively to the
                    economic development of countries. Understanding how to use
                    them effectively and learning more about sustainability will
                    form the base for this course. Get a deep understanding on
                    metals industry , mining industry and forest products
                    industry and latest trends in these areas.
                  </p>
                  {/* <a href="#">Coming Soon</a> */}
                </div>
              </div>
            </div>
          </div>
          {/* <div className="SSA-wrap">
                        <div className="SSA-row">
                            
                        </div>
                    </div> */}
        </div>
      </div>
    </>
  );
}

export default Industry;
